import _ from 'lodash'
import { doesIssueSatisfySchema, TagIssueConstraintSchema } from './tagIssueSchemaEngine'
import { SsmlValidationIssue } from '../../types'
import { isAudioIssue, isTagIssue } from '../general'

const TREAT_AS_VALID_RESULT_SCHEMA: TagIssueConstraintSchema = [
  { tag: 'math', constraints: [{ type: 'always' }] },
  { tag: 'lang', constraints: [{ type: 'always' }] },
  { tag: 'audio', constraints: [{ type: 'always' }] },
  { tag: 'voice', constraints: [{ type: 'always' }] },
  { tag: 'lexicon', constraints: [{ type: 'always' }] },
  { tag: 'phoneme', constraints: [{ type: 'always' }] },
  { tag: 'bookmark', constraints: [{ type: 'always' }] },
  { tag: 'mstts:viseme', constraints: [{ type: 'always' }] },
  { tag: 'mstts:silence', constraints: [{ type: 'always' }] },
  { tag: 'sub', constraints: { alias: [{ type: 'always' }] } },
  { tag: 'mstts:express-as', constraints: [{ type: 'always' }] },
  { tag: 'mstts:audioduration', constraints: [{ type: 'always' }] },
  { tag: 'mstts:backgroundaudio', constraints: [{ type: 'always' }] },
  {
    tag: 'break',
    constraints: {
      time: [{ type: 'range', from: 0, to: 10000, unit: 'ms' }],
      strength: [
        { type: 'values', enum: new Set(['x-weak', 'weak', 'medium', 'strong', 'x-strong']) }
      ]
    }
  },
  {
    tag: 'emphasis',
    constraints: {
      level: [{ type: 'values', enum: new Set(['reduced', 'none', 'moderate', 'strong']) }]
    }
  },
  {
    tag: 'say-as',
    constraints: {
      type: [{ type: 'always' }],
      detail: [{ type: 'always' }],
      format: [{ type: 'values', enum: new Set(['hms24', 'string', 'undefined']) }],
      'interpret-as': [{ type: 'values', enum: new Set(['string', 'telephone', 'alphanumeric']) }]
    }
  },
  {
    tag: 'prosody',
    constraints: {
      pitch: [
        { type: 'range', from: 0, to: 600, unit: 'hz' },
        { type: 'range', from: -100, to: 100, unit: '%' },
        { type: 'range', from: -1000, to: 1000, unit: 'st' },
        { type: 'values', enum: new Set(['x-low', 'low', 'medium', 'high', 'x-high', 'default']) }
      ],
      range: [
        { type: 'range', from: 0, to: 600, unit: 'hz' },
        { type: 'range', from: -100, to: 100, unit: '%' },
        { type: 'range', from: -1000, to: 1000, unit: 'st' },
        { type: 'values', enum: new Set(['x-low', 'low', 'medium', 'high', 'x-high', 'default']) }
      ],
      rate: [
        { type: 'range', from: -100, to: 100, unit: '' },
        { type: 'range', from: -100, to: 100, unit: '%' },
        { type: 'values', enum: new Set(['x-slow', 'slow', 'medium', 'fast', 'x-fast', 'default']) }
      ],
      volume: [
        { type: 'range', from: -100, to: 100, unit: '' },
        { type: 'range', from: -100, to: 100, unit: '%' },
        {
          type: 'values',
          enum: new Set(['silent', 'x-soft', 'soft', 'medium', 'loud', 'x-loud', 'default'])
        }
      ]
    }
  }
]

const getSchemaForTag = _.memoize((tag: string) =>
  TREAT_AS_VALID_RESULT_SCHEMA.find(item => item.tag.toLowerCase() === tag.toLowerCase())
)

export function shouldIssueBeIgnored(issue: SsmlValidationIssue) {
  if (isAudioIssue(issue) && issue.detail === 'Not correct audio format on HTTPS') {
    return true
  }

  if (isTagIssue(issue)) {
    return doesIssueSatisfySchema(issue, getSchemaForTag(issue.tag))
  }

  return false
}
